import React from 'react';
import _ from 'lodash';
import { IRootState } from 'stores/rematch/root-store';
import { BookingItemRow } from './components/details/BookingItemRow';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { IBooking } from 'interfaces/booking-interfaces';
import { useBookings } from 'views/bookings-v2/books-view-context/bookings-view-context';
import { usePortalUser } from 'utilities/react-hooks/use-portal-user';
import { BookingFilterAny } from 'stores/rematch/models/types/booking-filter';
import { timeZone } from 'interfaces/timezone-type';
import { BookingView } from 'stores/rematch/models/types/bookings-store';

interface BookingRowProps {
  currentFilterConfig?: BookingView | undefined;
  bookingItem: IBooking;
  onCheckItem: (bookingId: string) => void;
  onChangeFilter: (filters: BookingFilterAny[]) => void;
}

export const BookingRow = ({ currentFilterConfig, bookingItem, onCheckItem, onChangeFilter }: BookingRowProps) => {
  const portalUser = usePortalUser();
  const displayTimezone = useBookings((selector) => selector.displayTimezone);
  const selectedBookings = useSelector((selector: IRootState) => selector.bookingsStore.selectedBookings);
  const showTimezoneIndicator =
    !displayTimezone && moment.tz(bookingItem.timezone).format('Z') !== moment.tz(portalUser.timezone).format('Z');
  const checked =
    !_.isEmpty(_.find(selectedBookings, (b) => b.bookingId === bookingItem.bookingId)) &&
    _.find(selectedBookings, (b) => b.bookingId === bookingItem.bookingId)?.selected;

  return (
    <BookingItemRow
      timezone={displayTimezone as timeZone}
      showTimezoneIndicator={showTimezoneIndicator}
      bookingItem={bookingItem}
      checked={checked}
      onCheck={onCheckItem}
      customFilterFields={currentFilterConfig?.customFields}
      setFilter={onChangeFilter}
      key={bookingItem.bookingId}
    />
  );
};
